import api from 'utils/api';

const LOAD_TRIP = 'gtfs/LOAD_TRIP';
const SET_ACTIVE_TRIP = 'gtfs/SET_ACTIVE_TRIP';

export const receiveTrip = trip => ({type: LOAD_TRIP, trip});
export const setActiveTrip = tripId => ({type: SET_ACTIVE_TRIP, tripId});

const initialState = {
    trips: {},
    activeTrip: null,
    sorted: [],
    tinyData: [],
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_TRIP:
            const {trip_id} = action.trip;

            return {
                ...state,
                trips: {
                    ...state.trips,
                    [trip_id]: action.trip,
                },
            };

        case SET_ACTIVE_TRIP:
            return {
                ...state,
                activeTrip: action.tripId,
            };

        default:
            return state;
    }
}

// export const loadPhoto = photoId => (
//     (dispatch) => {
//         api.photoEdit.fetch({pk: photoId}).then((photo) => {
//             dispatch(receivePhoto(photo));
//         });
//     }
// );

export const loadTrip = tripId => (
    (dispatch) => {
        api.trip.fetch({pk: tripId}).then((trip) => {
            dispatch(receiveTrip(trip));
        });
    }
);

export const loadQuickDeps = stopId => (
    (dispatch) => {
        api.quickDeps.fetch(null, {stop_id: stopId}).then(routes => {
            dispatch({type: 'LOAD_STOPTIMES', routes});
        });
    }
);



// WEBPACK FOOTER //
// ./src/ducks/gtfs.js